export class HelpersService {
  install(Vue: any, options: any) { 
    Vue.prototype.$helpers = this;
  }

  afterBrowserRedraw(cb: () => void) {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        cb();
      });
    });
  }
}

export default new HelpersService();